
import { createSlice } from "@reduxjs/toolkit";

// Listen for localStorage changes to sync auth state across tabs
export const setupAuthStorageSync = (store) => {
    window.addEventListener('storage', (event) => {
        if (event.key === 'token') {
            store.dispatch(setToken(event.newValue || null));
        }
        if (event.key === 'logout') {
            store.dispatch(deleteUser());
        }
    });
};

const initialState = {
    users: [],
    currentUser: null,
    roles: [],
    token: null,
    isAuthenticated: false,
    status: "idle",
    error: null,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
            state.isAuthenticated = !!action.payload;
            // Sync with localStorage
            if (action.payload) {
                localStorage.setItem('token', action.payload);
            } else {
                localStorage.removeItem('token');
            }
        },
        addUser: (state, action) => {
            state.currentUser = action.payload;
            // Try to extract roles from user object (adjust as needed)
            state.roles = action.payload?.roles || action.payload?.role || [];
            // Keep users aligned with the active logged-in user.
            state.users = action.payload ? [action.payload] : [];
        },
        updateUser: (state, action) => {
            const index = state.users.findIndex(user => user.id === action.payload.id);
            if (index !== -1) {
                state.users[index] = action.payload;
            }
        },
        deleteUser: (state) => {
            state.users = [];
            state.currentUser = null;
            state.roles = [];
            state.token = null;
            state.isAuthenticated = false;
            // Clear localStorage
            localStorage.removeItem('token');
        },
        // New action to initialize auth from localStorage
        initializeAuth: (state) => {
            const token = localStorage.getItem('token');
            if (token) {
                state.token = token;
                state.isAuthenticated = true;
            }
        },
    },
});

export const { setToken, addUser, updateUser, deleteUser, initializeAuth } = userSlice.actions;
export default userSlice.reducer;

